import axios from "axios";
import Common from "../../componets/Common";

const initialData = {
  transaccionId: "",
  urlPowerpay: "",
  statusPowerpay: "",
  mensajeError: "",
}

export const  verificarExistenciaTransaccion = async (idOrden, config) => {  

  const url = `${Common.urlAPI}/VerificarExistenciaPowerpay/${idOrden}`;    

  try {
    const resp = await axios.get( url, config );
    
    return {
      ...initialData,
      transaccionId: resp.data.transaccionId,
      urlPowerpay: resp.data.urlPowerpay,
      statusPowerpay: resp.data.statusPowerpay,
    }

  } catch (err) {
    console.log('error', err.response);
    const mensajeError = err.response && err.response.status === 401 ? "El token es invalido para este usuario" : err.toString();
    return {
      ...initialData,
      mensajeError
    }
  }
  
}
